var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isLoggedIn
    ? _c(
        "div",
        { staticStyle: { "background-color": "#f5f6fa" } },
        [
          _c("flash-message", {
            staticClass: "alert-system",
            attrs: { transitionIn: "animated swing" },
          }),
          _c(
            "nav",
            {
              staticClass: "navbar navbar-expand fixed-top",
              staticStyle: { "max-height": "63px !important" },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c(
                  "a",
                  {
                    staticClass: "navbar-brand text-primary",
                    attrs: { href: "#" },
                  },
                  [
                    _c("img", {
                      staticClass: "d-block",
                      attrs: {
                        src: "/img/LogoPortoBank1.svg",
                        height: "23 vh",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.login()
                        },
                      },
                    }),
                  ]
                ),
                _c("p", { staticClass: "title-space mb-2 mt-2" }, [
                  _vm._v("Negocie Porto Bank"),
                ]),
                _c("ul", { staticClass: "navbar-nav ml-auto text-secondary" }, [
                  _c("a", {
                    staticClass:
                      "sidebar-brand d-flex align-items-right justify-content-right",
                    attrs: { href: "index.html" },
                  }),
                  _vm._m(0),
                  _c(
                    "li",
                    {
                      staticClass: "nav-item dropdown no-arrow text-secondary",
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link dropdown-toggle",
                          attrs: {
                            href: "#",
                            id: "userDropdown",
                            role: "button",
                            "data-toggle": "dropdown",
                            "aria-haspopup": "true",
                            "aria-expanded": "false",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.eventClickMenuSuperiorGTM()
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "mr-2 small" }, [
                            _vm._v(_vm._s(_vm.user.FullName.split(" ")[0])),
                          ]),
                          _c("i", {
                            staticClass: "fa fa-angle-down fa-lg",
                            staticStyle: { "font-size": "25px" },
                          }),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass:
                            "dropdown-menu dropdown-menu-right shadow animated--grow-in",
                          attrs: { "aria-labelledby": "userDropdown" },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.alterarCadastro()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-user-o fa-sm fa-fw mr-2",
                              }),
                              _vm._v(" Cadastro "),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "dropdown-item",
                              on: {
                                click: function ($event) {
                                  return _vm.alterarSenha()
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass: "fa fa-key fa-sm fa-fw mr-2",
                              }),
                              _vm._v(" Alterar código "),
                            ]
                          ),
                          _c("div", { staticClass: "dropdown-divider" }),
                          _c(
                            "a",
                            {
                              staticClass: "dropdown-item",
                              attrs: {
                                href: "#",
                                "data-toggle": "modal",
                                "data-target": "#logout",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.eventClickOptionsMenuSuperiorGTM(
                                    "logout"
                                  )
                                },
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "fa fa-sign-out fa-sm fa-fw mr-2 text-gray-400",
                              }),
                              _vm._v(" Logout "),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
            ]
          ),
          _c("router-view"),
          _c(
            "div",
            { staticClass: "modal fade mt-5", attrs: { id: "logout" } },
            [
              _c(
                "div",
                {
                  staticClass: "modal-dialog modal-sm",
                  attrs: { role: "document" },
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _vm._m(1),
                    _vm._m(2),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-dark px-5",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              return _vm.eventDoLogoutGTM()
                            },
                          },
                        },
                        [_vm._v("Sair")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-dark text-white",
                          attrs: { type: "button", "data-dismiss": "modal" },
                        },
                        [_vm._v(" Voltar ")]
                      ),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _c(
            "a",
            {
              staticClass: "whatsapp-link",
              attrs: {
                href: "https://porto.vc/whatsapp-oficial",
                target: "_blank",
              },
              on: { click: _vm.saveLogcontatoWhatsApp },
            },
            [
              _c("i", {
                class: [
                  _vm.largura < 500
                    ? "fa fa-whatsapp fa-2x"
                    : "fa fa-whatsapp fa-3x",
                ],
              }),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", { staticClass: "nav-item dropdown no-arrow" }, [
      _c("a", {
        staticClass:
          "sidebar-brand d-flex align-items-right justify-content-right",
        attrs: { href: "index.html" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c("h6", { staticClass: "modal-title text-primary" }, [_vm._v("Logout")]),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: { type: "button", "data-dismiss": "modal" },
        },
        [_c("span", [_vm._v("×")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-body" }, [
      _c("h6", [_vm._v("Deseja encerrar a sessão?")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }